// @flow
import React from 'react';

import { Button } from 'primitive-components';
import { Grid } from 'layout-core-components';

import TransactionSidebarBorderedSection from './TransactionSidebarBorderedSection';

type TransactionSidebarFooterButtonProps = {
  onViewEntireTransaction: () => {},
};

export default function TransactionSidebarFooterButton({
  onViewEntireTransaction,
}: TransactionSidebarFooterButtonProps) {
  return (
    <TransactionSidebarBorderedSection>
      <Grid row="1fr max-content 1fr">
        <span />
        <Button iconRight="chevronDown" subtle onClick={onViewEntireTransaction}>
          View Entire Transaction
        </Button>
        <span />
      </Grid>
    </TransactionSidebarBorderedSection>
  );
}
